import { OnInit, OnDestroy, QueryList, ViewChildren } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';

import {
  PageBase,
  BackendService,
  FormModeEnum,
  TableModeEnum,
  FilterOptions,
  TableActionFilterParams,
  FieldStructure,
  TableSettings,
  FilterSettings,
  ViewTableComponent,
  ToolbarAction,
  FieldMapItem,
} from 'beyond-util';
import { ActionType } from '../../../enums/action-type.enum';
import * as moment from 'moment';

export class IzvestajBaseComponent extends PageBase
  implements OnInit, OnDestroy {
  actionType: any;
  constructor(protected _backendService: BackendService) {
    super(_backendService);
  }

  FormModeEnum = FormModeEnum;
  TableModeEnum = TableModeEnum;

  filterOptions: FilterOptions;

  orderList: any[];
  mode = FormModeEnum.Edit;

  protected extraFieldVisible: boolean;
  protected extraFieldValue: string;

  protected settingsTableSource = new Subject<any>();
  protected settingsTable$ = this.settingsTableSource.asObservable();
  protected settingsChangedSubscription: Subscription;

  protected documentListSource = new Subject<any>();
  protected documentList$ = this.documentListSource.asObservable();

  protected lastUsedFilter: TableActionFilterParams;

  protected fieldStructure: FieldStructure;
  public report: any = {};

  get hasOrderList() {
    return this.orderList && this.orderList.length;
  }
  get order(): any {
    return this.report;
  }

  set order(value: any) {
    this.report = value;
    this.infobarDocument = value;
  }

  protected settingsData: any;

  protected settingsTable: TableSettings;
  protected settingsFilter: FilterSettings;

  @ViewChildren(ViewTableComponent)
  protected tables: QueryList<ViewTableComponent>;

  ngOnInit() {
    this.settingsLoadSingle();
    this.setToolbar();
  }

  setToolbar() {
    this.setToolbarOptions({
      toolbarVisible: true,
      showExport: true,
      showPrint: true,
      showClose: false,
      showComments: false,
      showPrethodnici: false,
      showAttachments: false,
    });
  }

  allFieldsEditable(fieldStructure: FieldStructure): void {
    fieldStructure.fieldList.forEach(f => {
      f.additable = true;
      f.editable = true;
    });
  }

  ngOnDestroy() {
    if (this.settingsChangedSubscription) {
      this.settingsChangedSubscription.unsubscribe();
    }
  }

  settingsLoadSingle() {}

  firstTableLoad() {
    this.lastUsedFilter = {
      pageCurrent: 1,
      filterQuery: '',
      filterDate: '',
      filterObjects: [],
      filterCombined: null,
      rowsOnPage: 10,
      sortOrder: {},
      direction: 'asc',
      relations: [],
    };
  }

  onToolbarAction(event) {
    switch (event) {
      case ToolbarAction.Export:
        this.onToolbarActionExport();
        break;
      case ToolbarAction.Print:
        this.onToolbarActionPrint();
    }
  }

  getResponseData(response: any) {
    return response.ServiceData.Data && response.ServiceData.Data.length
      ? response.ServiceData.Data
      : response.ServiceData && response.ServiceData.length
      ? response.ServiceData
      : [];
  }

  splitDetails(
    settings: any,
    firstColumnSize?: number,
    secColSmallerOrEqual: boolean = true
  ) {
    const allDetails = settings.formSettings.header[0].panels[0].controls[0];
    const newFirstCol = [];
    const newSecondCol = [];

    if (!firstColumnSize) {
      firstColumnSize = Math.ceil(allDetails.length / 2);
    } else if (firstColumnSize > allDetails.length) {
      console.log(
        'Setovan broj podataka po koloni je veći od ukupnog broja podataka!'
      );

      firstColumnSize = Math.ceil(allDetails.length / 2);
    }

    if (
      secColSmallerOrEqual &&
      allDetails.length - firstColumnSize > firstColumnSize
    ) {
      firstColumnSize = allDetails.length - firstColumnSize;
    }

    for (let i = 0; i < allDetails.length; i++) {
      if (i < firstColumnSize) {
        newFirstCol.push(allDetails[i]);
      } else {
        newSecondCol.push(allDetails[i]);
      }
    }

    settings.formSettings.header[0].panels[0].controls[0] = newFirstCol;
    settings.formSettings.header[0].panels[0].controls[1] = newSecondCol;
  }

  refreshTable() {}

  onToolbarActionPrint() {}
  onToolbarActionExport() {}

  validirano(isValid: boolean) {
    if (isValid) {
      switch (this.actionType) {
        case ActionType.Create:
          this.filter();
          break;
      }
    }
  }

  getExcelFileName(reportName: string) {
    const formattedDate: string = `${moment(new Date()).format(
      'YYYY-MM-DD_HH:mm'
    )}`.replace(
      `${moment(new Date()).format('YYYY-MM-DD_HH:mm')}`.charAt(13),
      '-'
    );
    const fileName = `${reportName}_${formattedDate}`;

    return fileName;
  }

  filter() {}

  setActionType(action: ActionType) {
    this.actionType = action;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/izvestaji/izvestaj-base/izvestaj-base.component.ts